module.exports = __webpack_public_path__ + "img/img-1@2x.cb194d19.png";